import { type MouseEvent } from 'react';

import { SELECTION_RIGHT_OVERFLOW } from '../components/interactions-overlay/constants.js';

type ClientPosition = Pick<MouseEvent, 'clientY' | 'clientX'>;

export const calculateMousePositions = (
  { clientY, clientX }: ClientPosition,
  target: EventTarget & Element,
) => {
  const { top, left, width } = target.getBoundingClientRect();

  return {
    absolute: {
      x: clientX,
      y: clientY,
    },
    relative: {
      x: Math.min(
        Math.max(clientX - left, 0),
        width + SELECTION_RIGHT_OVERFLOW,
      ),
      y: clientY - top,
    },
  };
};
